import { trpc } from "@/trpc";
import { Button } from "@acme/ui/button";
import { Input } from "@acme/ui/input";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router";

export const JoinPage = () => {
	const navigate = useNavigate();
	const [shareParams, setShareParams] = useSearchParams();
	const [shareCode, setShareCode] = useState("");

	useEffect(() => {
		const codeFromUrl = shareParams.get("c");
		if (codeFromUrl) {
			console.log("codeFromUrl", codeFromUrl);
			// navigate(`/editor/${codeFromUrl}`);
		}
	}, [shareParams, navigate]);

	const mutation = trpc.post.shareCodeExchange.useMutation({
		onSuccess: (shareCode) => {
			if (shareCode) {
				navigate(`/editor/${shareCode}`);
			}
		},
	});

	return (
		<div className="flex flex-col items-center justify-center gap-3">
			<div className="text-primary">Enter share code:</div>
			<Input
				placeholder="Enter share code"
				value={shareCode}
				onChange={(e) => setShareCode(e.target.value)}
			/>
			<div className="flex flex-row gap-3">
				<Button variant="ghost" onClick={() => navigate(-1)}>
					Back
				</Button>
				<Button
					disabled={shareCode.length <= 0 || mutation.isPending}
					onClick={() => mutation.mutate(shareCode)}
				>
					{mutation.isPending ? "Pending" : "Join"}
				</Button>
			</div>
		</div>
	);
};

export default JoinPage;
